(ns frontend.ui.component.lp-portal.report.body.innovestor.holding.controller
  (:require
   [frontend.ui.component.lp-portal.report.component.multi-chart.controller :as multi-controller]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.controller :refer [block-table-raw-data->editable-data
                                                                                         invest-europe-editable-data->raw-data
                                                                                         invest-europe-table-raw-data->editable-data]]))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:holding-name           (get-in report-data [:holding-name])
   :reference-date         (get-in report-data [:reference-date])
   :reporting-period       (get-in report-data [:reporting-period])
   :report-id              (:report-id props)
   :company-information    (report-ctl/with-footnote
                            props
                            :company-information-footnotes
                            (:company-information report-data))
   :investment-information (report-ctl/with-footnote
                            props
                            :investment-information-footnotes
                            (:investment-information report-data))
   :status-and-events      (report-ctl/rich-content
                            props
                            :status-and-events-text)
   :exit-strategy          (report-ctl/rich-content
                            props
                            :exit-strategy-text)
   :holding-image          (report-ctl/image-content
                            props
                            :holding-image-footnotes
                            (:holding-image dynamic-data))})

(defn ->tech-holding-ui-data
  [{:keys [report-data] :as props}]
  {:holding-name           (get-in report-data [:holding-name])
   :reference-date         (get-in report-data [:reference-date])
   :reporting-period       (get-in report-data [:reporting-period])
   :report-id              (:report-id props)
   :company-information (->> (report-ctl/with-footnote
                               props
                               :company-information-footnotes
                               (:company-information report-data))
                             (report-ctl/with-editable-tables (merge {:fixed-columns? true
                                                                      :fixed-labels? true} props) :company-information
                               block-table-raw-data->editable-data
                               invest-europe-editable-data->raw-data))
   :investment-information (->> (report-ctl/with-footnote
                                  props
                                  :investment-information-footnotes
                                  (:investment-information report-data))
                                (report-ctl/with-editable-tables (merge {:fixed-columns? true
                                                                         :fixed-labels? true} props) :investment-information
                                  block-table-raw-data->editable-data
                                  invest-europe-editable-data->raw-data))
   :status-and-events      (report-ctl/rich-content
                            props
                            :status-and-events-text)
   :financial-performance-chart (->>
                                 (get-in report-data
                                         [:financial-performance-chart])
                                 (report-ctl/with-footnote
                                   props
                                   :financial-performance-chart-footnotes)
                                 (report-ctl/with-editable-charts
                                   (merge {:multi-chart? true} props)
                                   :financial-performance-chart
                                   multi-controller/multi-chart-ctl
                                   multi-controller/config->editable-data
                                   multi-controller/editable-data->raw-data))
   :financial-performance-table (->> (report-ctl/with-footnote
                                       props
                                       :financial-performance-table-footnotes
                                       (:financial-performance-table report-data))
                                     (report-ctl/with-editable-tables props :financial-performance-table
                                       invest-europe-table-raw-data->editable-data
                                       invest-europe-editable-data->raw-data))})

